import { useNavigate } from 'react-router-dom';
import {
  ClientDeleteDialog,
  ClientEditDialog,
} from '../../0_presentation/client/components/dialogs';
import { Client } from '../../2_domain/client/client';
import IClientRepository from '../../2_domain/client/iClientRepository';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';
import useDialog from '../core/components/feedback/useDialog';

const useClientDetailPageController = (client: Client) => {
  const dialog = useDialog();
  const navigate = useNavigate();
  const clientRepo = Get.find<IClientRepository>('IClientRepository');

  const onManageHandler = (manageKind: 'Edit' | 'Delete') => {
    if (manageKind === 'Edit') {
      dialog.openDialog(
        <ClientEditDialog
          client={client}
          onCancel={async () => dialog.closeDialog()}
          onSave={async (newClient) => {
            await promiseResolver<void>({
              promise: clientRepo.updateClient(newClient),
              successCallback: () => {
                dialog.closeDialog();
                navigate(0);
              },
            });
          }}
        ></ClientEditDialog>
      );
    } else if (manageKind === 'Delete') {
      dialog.openDialog(
        <ClientDeleteDialog
          client={client}
          onDeleteClient={async () => {
            await promiseResolver<void>({
              promise: clientRepo.deleteClient(client.id, false),
              successCallback: () => {
                dialog.closeDialog();
                navigate(`../list`, { replace: true });
              },
            });
          }}
          onDeleteClientAndContent={async () => {
            await promiseResolver<void>({
              promise: clientRepo.deleteClient(client.id, true),
              successCallback: () => {
                dialog.closeDialog();
                navigate(`../list`, { replace: true });
              },
            });
          }}
        ></ClientDeleteDialog>
      );
    } else {
      return;
    }
  };

  return {
    client,
    onManageHandler,
  };
};

export default useClientDetailPageController;
